<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'90%'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>Response Headers</span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span v-if="apenasVisualizar">
                    Este é o response headers para a requisição de numero {{requisicaoEditar.id}}:
                </span>
                <span v-else>
                    Escreva os response headers para a requisição de numero {{requisicaoEditar.id}}:
                </span>

                <br>

                <v-divider class="my-3"/>

                <campo-vazio-mensagem v-if="apenasVisualizar && !responseHeaders" :mensagem="'Não há conteúdo no response headers desta requisição!'"/>

                <span style="white-space: pre-wrap" v-if="apenasVisualizar">{{responseHeaders}}</span>

                <v-textarea v-if="!apenasVisualizar"
                            v-model="responseHeaders"
                            :error-messages="errors.collect('Response Headers' + requisicaoEditar.id)"
                            v-validate="''"
                            :name="'Response Headers id' + requisicaoEditar.id"
                            label="Response Headers"
                            placeholder="Digite os headers"
                            rows="6"/>

            </v-card-text>

            <v-card-actions>
                <v-layout v-if="apenasVisualizar" class="justify-center">
                    <az-call-to-action id="botaoFechar"
                                       @click="$emit('cancelar')"
                                       css-class="botao-desativado" class="ma-2 py-2"
                                       slot="actions">
                        Fechar
                    </az-call-to-action>
                </v-layout>
                <v-flex v-else>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoCancelar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoConfirmar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CampoVazioMensagem from './CampoVazioMensagem'
export default {
    name: 'ModalEditarResponseHeadersRequisicao',
    components: {CampoVazioMensagem},
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        },
        apenasVisualizar:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            responseHeaders: null,
        }
    },
    computed: {
        requisicaoResponseHeaders() {
            return this.requisicaoEditar.responseHeaders
        }
    },
    mounted(){
        this.responseHeaders = this.requisicaoResponseHeaders
    },
    methods:{
        confirmar() {
            this.requisicaoEditar.responseHeaders = this.responseHeaders
            this.$emit('confirmar', this.requisicaoEditar)
        },
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
